<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { type paramsSerializationOptions } from '../../../../../composables/use-endless-scroll-api'
import type ApiInterface from '../../../../../types/api-interface'
import EnumSelectMultiple from '../../../../selects/enum-select-multiple'
import { type ComputedColumnInterface } from '../../../DefaultTableInterfaces'
import { MultipleRelationSelectTableFilter } from '../../../filters/Filters'
import { type MultipleEnumSelectHeaderInterface } from '../../HeadersTableInterfaces'
import HeaderSort from '../DefaultTableHeaderSort.vue'
import { type FilterData } from '../../../filters/Filters'
import { prepareSmartFilterParams } from '../prepareSmartFilterParams'

export default defineComponent({
  props: {
    api: {
      type: Object as PropType<ApiInterface>,
      default: undefined,
    },
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    enableSorting: {
      type: Boolean,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
    },
    onSort: {
      type: Function as PropType<() => void>,
    },
    params: {
      type: Array as PropType<FilterData[]>,
    },
    paramsSerialization: {
      type: String as PropType<paramsSerializationOptions>,
      default: 'default',
    },
  },
  setup(props) {
    const filter = props.column.filter as MultipleRelationSelectTableFilter
    const header = props.column.header as MultipleEnumSelectHeaderInterface

    const setValue = (val: Array<{ id: string, name: string }>) => {
      filter.addValue(val)
    }

    const params = computed(() => prepareSmartFilterParams(props.column.hash, header.params || {}, props.params))

    return () => (

      <div class="ark-ui-table-relation-select-header default-table-header">
        <EnumSelectMultiple
          api={props.api}
          dataProvider={header.dataProvider}
          placeholder={props.column.name}
          modelValue={filter.value}
          onValueChange={setValue}
          endpoint={filter.endpoint}
          itemConverter={header.itemConverter}
          params={params.value}
          paramsSerialization={header.paramsSerialization || props.paramsSerialization}
          additionalItems={header.additionalItems}
          showItemsCount={5}
        />

        { props.enableSorting && props.onSort && (
          <HeaderSort column={props.column} onSort={props.onSort} sortField={props.sortField} sortOrder={props.sortOrder}/>
        ) }
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-relation-select-header {
  display: flex;
  align-items: center;

  > *:first-child {
    width: 100%;
  }

  &.active,
  &:hover {
    & path {
      fill: #585B69;
    }
  }
}
</style>
